import React from "react"
import { AppAffectedList, AppSitesAutocomplete, AppValueChip } from "@components"
import { useComputed } from "@preact/signals-react"
import { useLocation } from "react-router-dom"
import { reportListMultipleData, selectedReportTypeTab } from "Pages/ReportsAlerts/Reports/@signals"
import { REPORT_TYPE_SITE_FILTERS } from "Pages/ReportsAlerts/Reports/@constants"
import { BACKEND_APIS, REPORT_ROUTES } from "@constants"
import { FlagsIconSeeker } from "@ui-seeker/core"
import { useReportMultipleModalMultipleEdit } from "Pages/ReportsAlerts/Reports/@hooks/multipleModalActions"


export default function ReportMultiModalSiteSection() {

	const { data, setData } = useReportMultipleModalMultipleEdit()
	const siteFilters = REPORT_TYPE_SITE_FILTERS[selectedReportTypeTab.value]
	const { pathname } = useLocation()
	const isExtra = pathname === REPORT_ROUTES.EXTRA_PATH
	const siteUrl = isExtra ? `${BACKEND_APIS.MASTER_DATA}/options/site-extras` : undefined

	return <>
		<AppSitesAutocomplete
			value={data}
			onChange={e => setData(e.target.value)}
			{...(siteUrl && { urlAjax: siteUrl })}
			{...(siteFilters && { filters: siteFilters })}
		/>
		<ReportMultiModalSiteDetails/>
	</>
}

function ReportMultiModalSiteDetails() {

	const reportsInfo = useComputed(() => reportListMultipleData.value.reportsInfo)

	return <AppAffectedList
		hint="current sites"
		rows={reportsInfo.value.map(({ name, sitesName }, idx) => ({
			key: `${name}-${idx}`,
			name,
			content: sitesName?.length
				? sitesName.map(({ name: site, market }, siteIdx) => <AppValueChip key={`${site}-${siteIdx}`}>
					<FlagsIconSeeker countryName={market}/>
					{site}
				</AppValueChip>)
				: <AppValueChip tone="empty">No sites</AppValueChip>,
		}))}
	/>
}
